import {useStore} from 'vuex'

export default {
    name: "ActiveRoleListCard",
    props: {
        roleCardData: {
            type: Object,
            required: true
        }
    },
    setup(props){
        const store = useStore()

        const startDeleteRoleOverlay = function(e){
            store.commit('main/set_page_overlay_content_data', { groupRoleId: props.roleCardData.id })
            store.dispatch('main/openPageOverlay',{
                overlayContent: 'DeleteRoleOverlay',
                returnTarget: e.currentTarget
            })
        }

        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: "ActiveRolesList", labelKey: labelKey })


        return {
            getLabel,
            startDeleteRoleOverlay
        }
    }
}